/**
 * The helpdesk's ticket fields, for every setting that fills them in when Kim closes a ticket.
 * One cache entry per brand, shared by each page that offers them.
 */

import { useAtom, type Getter } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { inboundFilterService } from '@/services';
import { buScopeKey, buScopeParams } from '@/lib/business-unit-scope';

// Fetch only while the caller's auto-close is on: it is a round trip to the helpdesk. Keyed apart from
// the settings themselves, since saving a setting changes nothing here.
export const helpdeskTicketFieldsQuery = (get: Getter, enabled: boolean) => ({
  queryKey: ['helpdesk-ticket-fields', buScopeKey(get)],
  queryFn: () => inboundFilterService.getTicketFields(buScopeParams(get)),
  enabled,
  refetchOnWindowFocus: false
});

// Read on demand, e.g. by the protocol editor's field picker: mounting the hook is what fetches.
const helpdeskTicketFieldsQueryAtom = atomWithQuery((get) => helpdeskTicketFieldsQuery(get, true));

export function useHelpdeskTicketFields() {
  const [query] = useAtom(helpdeskTicketFieldsQueryAtom);
  return query;
}
